<template>
  <div>
    <b-modal v-model="$store.state.showProfileForm" :title="$t('updateProfile')" @ok="profile" @show="showProfile" :no-close-on-backdrop="true" :no-enforce-focus="true">
      <form-input :label="$t('name')" :model="profileModel" type="text" attribute="name" :errors="errors"></form-input>
      <form-input :label="$t('phone')" :model="profileModel" type="text" attribute="phone" :errors="errors"></form-input>
      <form-textarea :label="$t('desc')" :model="profileModel" attribute="desc" :errors="errors"></form-textarea>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="$store.state.showProfileForm = false">Cancel</b-button>
        <b-button :disabled="loading" variant="primary" class="float-right" @click="profile">
          <b-spinner v-if="loading" small></b-spinner>
          <span>OK</span>
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="$store.state.showPasswordForm" :title="$t('changePassword')" :no-close-on-backdrop="true" :no-enforce-focus="true">
      <form-input :label="$t('oldPassword')" type="password" :model="passwordModel" attribute="oldPassword" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
      <form-input :label="$t('password')" type="password" :model="passwordModel" attribute="password" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
      <form-input :label="$t('rePassword')" type="password" :model="passwordModel" attribute="rePassword" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="$store.state.showPasswordForm = false">Cancel</b-button>
        <b-button :disabled="loading" variant="primary" class="float-right" @click="password">
          <b-spinner v-if="loading" small></b-spinner>
          <span>OK</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      profileModel: {},
      passwordModel: {},
      errors: {},
      loading: false,
    };
  },

  i18n: {
    messages: {
      en: {
        updateProfile: 'Update profile',
        changePassword: 'Change password',
        name: 'Your name',
        phone: 'Phone',
        desc: 'About you',
        oldPassword: 'Current password',
        password: 'New password',
        rePassword: 'Confirm new password',
        passwordPlaceholder: 'Password',
        success: 'Success',
        error: 'Error',
        profileUpdated: 'Your profile has been updated successfully!',
        profileUpdateFailed: 'Cannot update your profile now, please try again!',
        passwordUpdated: 'Your password has been updated successfully!',
        passwordUpdateFailed: 'Cannot update your password now, please try again!'
      },
      vi: {
        updateProfile: 'Cập nhật hồ sơ',
        changePassword: 'Đổi mật khẩu',
        name: 'Tên của bạn',
        phone: 'Số điện thoại',
        desc: 'Giới thiệu bản thân',
        oldPassword: 'Mật khẩu hiện tại',
        password: 'Mật khẩu mới',
        rePassword: 'Xác nhận mật khẩu',
        passwordPlaceholder: 'Mật khẩu',
        success: 'Thành công',
        error: 'Có lỗi',
        profileUpdated: 'Hồ sơ cá nhân của bạn đã được cập nhật thành công!',
        profileUpdateFailed: 'Hiện không thể cập nhật hồ sơ cá nhân của bạn, xin thử lại sau!',
        passwordUpdated: 'Mật khẩu của bạn đã được cập nhật thành công!',
        passwordUpdateFailed: 'Hiện không thể thay đổi mật khẩu của bạn, xin thử lại sau!'
      }
    }
  },
  methods: {
    showProfile: function () {
      let loader = this.$loading.show();
      this.$service.get('/profile').then(response => {
        this.profileModel = response.data;
      }).finally(() => {
        loader.hide();
      });
    },
    profile: function (evt) {
      evt.preventDefault();
      this.loading = true;
      this.errors = {};
      this.$service.put('/profile', this.profileModel).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('profileUpdated'),
            icon: 'success'
          });
          this.$store.commit('user', response.data);
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('profileUpdateFailed'),
            icon: 'error'
          });
        }
        this.$store.commit('showProfileForm', false);
      }).catch(error => {
        this.errors = error.response.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    password: function (evt) {
      evt.preventDefault();
      this.loading = true;
      this.errors = {};
      this.$service.put('/profile/password', this.passwordModel).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('passwordUpdated'),
            icon: 'success'
          });
          sessionStorage.removeItem('token');
          localStorage.removeItem('token');
          this.$service.defaults.headers.common['token'] = null;
          this.$bgService.defaults.headers.common['token'] = null;
          this.$store.commit('user', null);
          location.href = '#/login';
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('passwordUpdateFailed'),
            icon: 'error'
          });
        }
        this.passwordModel = {};
        this.$store.commit('showPasswordForm', false);
      }).catch(error => {
        this.errors = error.response.data;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
};
</script>